import { Grid } from "@mui/material";
import Tabs from "Pages/Hiload/components/VehicleViewTabs/Tabs";
import React, { useState } from "react";
import Box from "ReusableComponents/Box";
import { COLORS, SIZES, WEIGHT } from "theme";
import Text from "ReusableComponents/Text";
import { useLanguage } from "LanguageContext";

const LanguageSelector = ({ languages, leave, small }) => {
  const [hover, setHover] = useState(false);
  const { selectedLanguage, setLanguage } = useLanguage();

  const handleHover = (id) => {
    setHover(id + 1);
  };

  const handleLanguageChange = (event) => {
    const newLanguage = event.toLowerCase();

    setLanguage(newLanguage);

    const currentPath = window.location.pathname;
    const pathSegments = currentPath.split("/");
    pathSegments[1] = newLanguage;
    const newPath = pathSegments.join("/");

    window.history.pushState({}, "", newPath);
    window.location.reload();
  };

  return (
    <Grid
      container
      spacing={2}
      onMouseLeave={leave}
      style={{
        zIndex: 5,
        position: "absolute",
        width: "15vh",
        paddingTop: small ? "80px" : "0",
        top: small ? "0" : "84px", // Set a fixed position without any condition
        right: small ? "4%" : "8.5%",
        boxShadow: "0px 15px 40px #0000001F",
      }}
    >
      <Box background={COLORS.white} padding={10}>
        <Grid item xs={12}>
          <Tabs
            notMargin
            fromProducts
            active={0}
            isBottomBorder={false}
            fromHiload
            // tabs={["Three Wheelers"]}
          />
        </Grid>

        {languages?.map((language, i) => {
          return (
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              style={{
                padding: "0px 5px",
                textAlign: "center",
                background: COLORS.white,
              }}
              onClick={() => {
                leave();
                handleLanguageChange(language.value);
              }}
              onMouseEnter={() => handleHover(i)}
              onMouseLeave={() => handleHover(0)}
            >
              <Box
                display="flex"
                cursor="pointer"
                flexDirection="column"
                padding="0px"
                background={
                  selectedLanguage.toUpperCase() == languages[i].value
                    ? COLORS.primary
                    : COLORS.white
                }
              >
                <Text
                  fontSize={small ? "8px" : "10px"}
                  textColor={COLORS.black}
                  fontWeight={WEIGHT.bold}
                >
                  {languages[i].name}
                </Text>
              </Box>
            </Grid>
          );
        })}
      </Box>
    </Grid>
  );
};

export default LanguageSelector;
